var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaysafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "40px",
    viewBox: "0 0 64 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Playsafe_be") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Footer-Def",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-V---1920",
    transform: "translate(-1347.000000, -609.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Playsafe_be",
    x: 1347,
    y: 609,
    width: 63.4482759,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAdCAYAAADVV140AAAABGdBTUEAALGOfPtRkwAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAALqADAAQAAAABAAAAHQAAAAC0E+ZSAAAEmklEQVRYCc2XWYhOYRjHv88y2RlkyTbJoGwzQra4QLZEsqasqYm4kAtLbsieLCFuSISMrbgYjeICqbGMkewZ2bNkN4Tj9z/feY93vjnnaz5jPp76zfO8z/O8z/vOmXebSCTF4jjOVngHPVM8dPmGY2JLoRByTA/sTPgJl43vn2smcxs6m4lgd4GXIJkjP3q723KcKSav0jQDpUGrRAMQ7+BNqAhdw+Ri25NfTfszPIJqJuevaArWhpp2Mdof4Inti7eJ54CRzXYcpz155Sy0439sU2gZHIdikPyAw5CuouirIGkSNgixg26G49z19HA7F58m/8aLJfzr2f0S2hQz6/A5dj7c8QY4qo7Yu7z20LBCxNX3FnSDr/ACSv2itPeDZGBYnWT8VUi+6nUYFI1Gh2B3gWcwmkG0XgtBkh1TpX+S0xFPUzhH/2voRaBJ7yYWRRsx4wTWMUnl1fbEu3udqqLl/wkOXAFJ2ICDY+FIKyZ6CNs9QdAjYK4XkzIfwIxjhf7AZLBJIDkFm8EslX0qR7su6Oy9E1Qev/aDEW3kc6BLRmu6BNwjEt0YJAVBdZL2UcgcZW5VfmiN7oW6phi2Np0mb/vq0I6C9shTaKe21Wc8bR1/Gy1fNu06pl0hTaEq8BE04R7gn8OmML5DINFGPQE6iyX9Y8rZb3JTqhn8vDeBjKCBiS324lL68voL5EIWjIQGQf0q3cfA20AyNmgw/B1hLvQDf7kE5abKZ65ebZhXUOrWNJPgmLuFLSos/OLVKdIJsjzuUn9bsoX9zZRsx/LkM0ktobZM7Ap2a+xd8BJugI7HQmKP0UmL+eJJdwzqwORG4tc7W5eSar+FC6C74DWUMNHJ6AoJ4+ieSU7oVBUyg3rhvwydIfCD4D8b1C/MR747QbTG3AE6RPRPSHbyM49EdPPpsqoXMOBDfE/4qt8DYnI9o18zGWjdAW2hj9q24NPDrxjfJ3Q+9X5g6+GWB/po90tNnKSWsAV0bp+EeSTFS38cm2BDfIC21m3Y00DpWjI7qXsYredBDjSCeEnDcRPGQTcvWITWk/gejPF87hdIp+Bp6CAnWl+koZ/gGfj0yqsBK+B3gVifUfgWKBVdHwbAfHCPUPQQWOWVClXkTADdFwXwEMbBKtD8qkGG35nGZJjmO0IMco4rhK4Oegb7z1fsFnAfDoK+7BzoC3q4qU9jyJWdSMgxz5AMbN3Ue2EifAMtn+t+fxpDYbnvCDCItwd/iWDr5jxip9I+Y7fj7URxYsNgJWgz6p2jPXEMMqEhdAf3SWLv/nwG0W91AC1ba+o6G+Mr2ojWt443I8UY+o9pJnk6oyVfVJx2SaxZ5ud74vovKAOyoCtoKa2D1/BAm5Gc5uh3tG15YxplLiA6tCDYF7QppAtgiVdsN/ZnMDfsW+xCmAqzyXlA/7XYudiX0GWE+Aycqqt+oojcD+i/Kwy0BqarKjoPWsePgE9rUjG9NCfBrPiclLeZRC9YD81gT9gEiGnnay3WgvSwvErxM6BOijamOHYa5EJv0MRmm9i/1vbm1Fx0G+rr6gLQWlZ7B2vwIj5tIPn+C/kFeaxaM7tmzUMAAAAASUVORK5CYII="
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaysafe);
export default __webpack_public_path__ + "static/media/playsafe.b4f600ece6dd21ec23f3e81f7a25abae.svg";
export { ForwardRef as ReactComponent };